export function downloadFile(data, fileType, fileName) {
  const blob = new Blob([data], { type: fileType });

  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
